import React, { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { UnsavedDraftNavigationProvider } from '../../contexts/UnsavedDraftNavigationContext';

export default function AppRouter({ component: Component }: { component: React.ComponentType }) {
  const [router] = useState(() => createBrowserRouter([{ path: '*', element: <UnsavedDraftNavigationProvider><Component /></UnsavedDraftNavigationProvider> }]));
  return <RouterProvider router={router} />;
}
